module.exports = __webpack_public_path__ + "img/2-2.f2c6bfc0.svg";